import { Component, OnInit, Inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import {
  ENVIRONMENT_CONFIG,
  EnvironmentConfig,
} from '@cigna/chcp/shared/environment-util';

@Component({
  selector: 'cigna-impersonate-redirect',
  templateUrl: './impersonate-redirect.component.html',
  styleUrls: ['./impersonate-redirect.component.scss'],
})
export class ImpersonateRedirectComponent implements OnInit {
  constructor(
    private auth: AuthService,
    @Inject(ENVIRONMENT_CONFIG) private environment: EnvironmentConfig,
  ) {}

  ngOnInit() {
    this.auth.loginWithRedirect({
      appState: {
        target: '/dashboard',
      },
      authorizationParams: {
        connection: this.environment.auth0.impersonationConnection,
        redirect_uri: `${this.environment.auth0.redirect_uri}`,
      },
    });
  }
}
